export const APIs = {
    authLogin: `api/authentication/login`,
    forgotPassword: `api/authentication/forgot-password`,
    confirmForgotPasswordReset: `api/authentication/confirm-forgot-password`,
    acceptInvitation: `api/invitation/accept-invitation`,
    acceptAdminInvitation: `api/invitation/accept-admin-invitation`,
    acceptTeamLeadInvitation: `api/invitation/accept-team-lead-invitation`,
    verifyInvitation: `api/invitation/verify-invitation`,
    sendAuthCode: `api/invitation/send-auth-code`,
    refreshJwtToken: `api/authentication/refresh-token`,
    onlineCheck: `api/authentication/online-check`,
    verifyCellPhoneNumber: 'api/authentication/verify-cellphone-number',
};
//# sourceMappingURL=end-points.js.map